module.exports = __webpack_public_path__ + "static/media/W19-0522_Bistro_Burger_Desktop_wbug_2396x1473_FR.30508638.jpg";